const BelizeSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4152_110891)">
      <path
        d="M40 19.9997C40 13.1356 36.5415 7.07988 31.2724 3.47801L20 2.6084L8.72758 3.47793C3.45859 7.07988 0 13.1357 0 19.9997C0 26.864 3.45859 32.9196 8.72758 36.5214L20 37.3911L31.2724 36.5215C36.5415 32.9196 40 26.864 40 19.9997Z"
        fill="#0052B4"
      />
      <path
        d="M31.2729 3.47828C28.0631 1.28406 24.182 0 20.0004 0C15.819 0 11.9378 1.28406 8.72803 3.47828H31.2729Z"
        fill="#A2001D"
      />
      <path
        d="M8.72803 36.5215C11.9377 38.7157 15.819 39.9998 20.0004 39.9998C24.182 39.9998 28.0631 38.7157 31.2729 36.5215H8.72803Z"
        fill="#A2001D"
      />
      <path
        d="M20.0003 29.565C25.283 29.565 29.5655 25.2825 29.5655 19.9998C29.5655 14.7171 25.283 10.4346 20.0003 10.4346C14.7176 10.4346 10.4351 14.7171 10.4351 19.9998C10.4351 25.2825 14.7176 29.565 20.0003 29.565Z"
        fill="#F0F0F0"
      />
      <path
        d="M20.0004 27.825C24.3226 27.825 27.8265 24.3212 27.8265 19.9989C27.8265 15.6767 24.3226 12.1729 20.0004 12.1729C15.6782 12.1729 12.1743 15.6767 12.1743 19.9989C12.1743 24.3212 15.6782 27.825 20.0004 27.825Z"
        fill="#6DA544"
      />
      <path
        d="M20.0001 25.218C22.8816 25.218 25.2176 22.8821 25.2176 20.0006C25.2176 17.1191 22.8816 14.7832 20.0001 14.7832C17.1186 14.7832 14.7827 17.1191 14.7827 20.0006C14.7827 22.8821 17.1186 25.218 20.0001 25.218Z"
        fill="#F0F0F0"
      />
      <path
        d="M20.0004 18.6953L17.1743 19.9997V22.1736L20.0004 23.9127L22.8265 22.1736V19.9997L20.0004 18.6953Z"
        fill="#0052B4"
      />
      <path d="M17.1743 17.3916H22.8265V20.0003H17.1743V17.3916Z" fill="#FFDA44" />
    </g>
    <defs>
      <clipPath id="clip0_4152_110891">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default BelizeSvg;
